import React from 'react'
import { AdvertisingProvider } from "./src/context/AdvertisingContext"

export const wrapRootElement = ({ element }) => (
  <AdvertisingProvider>{element}</AdvertisingProvider>
)